/**
 * AppAuthContext - Contexto de autenticação usado pelo App.js e pelos componentes
 * extraídos em components/content/ (Fase 2 da refatoração).
 *
 * Extraído VERBATIM do App.js (mesma instância de AuthContext + hook useAuth) para
 * que os componentes movidos compartilhem EXATAMENTE o mesmo contexto provido pelo
 * <AuthContext.Provider> do App.js. Zero mudança de comportamento.
 */
import { createContext, useContext } from 'react';

// Auth Context
export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
